import React from "react";

function VendasIngresso({ reportData }) {
  return (
    <table className="min-w-full bg-white border border-solid border-gray-300">
      <thead className="bg-gray-300">
        <tr>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Grupo
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Código SC
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            QR Code
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Data/Hora de Emissão
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Operador
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            PDV
          </th>
          <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
            Forma de Pagamento
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((row, index) => (
          <tr key={index} className="hover:bg-gray-200">
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.GRUPOINGRESSO}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.CODINGRESSO}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.QRCODE}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {new Intl.DateTimeFormat("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }).format(new Date(row.DATAHORA))}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.RESPONSAVEL}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.CODPDV}
            </td>
            <td className="font-Roboto px-4 py-2 border-b text-sm">
              {row.FORMASPAGAMENTO[0]?.FORMAPGTO}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default VendasIngresso;
